import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { wilsonvilleConfig } from "./data";

export default function WilsonvillePage() {
  return <OregonCityPageTemplate config={wilsonvilleConfig} />;
}